import { FunctionalComponent, h } from '@stencil/core';
import { href } from 'stencil-router-v2';
import dayjs from 'dayjs'
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import { AppListItem, AppPagination } from '.';
import { genAnchor } from '../shared/helpers'
import state from '../store/store'

interface SectionList {
    __component?: string;
    filters?: any;
    content?: any;
    data?: any;
    meta?: any;
    searchParams?: any;
    slug?: string;
}

export const SectionList: FunctionalComponent<SectionList> = ({ searchParams, content, data, meta, filters, slug = 'news' }) => {

    const HideTitle = data.HideTitle || false;
    const AlignLeft = data.AlignLeft || false;

    const { Title, Description } = content
    const list = data.map(({ attributes }) => { return attributes })
    const { pagination: { page, pageCount } } = meta;
    const sortedFilters = sortBy(filters, ['attributes.Group', 'attributes.Label'])
    const groups = sortedFilters.map(item => item.attributes.Group).filter((value, index, self) => self.indexOf(value) === index);
    const groupMembers = {};
    sortedFilters.forEach(({ attributes: { Group }, id }) => { groupMembers[Group] = groupMembers[Group] ? [...groupMembers[Group], id] : [id] })
    const existingFilters = searchParams.get('filters')?.split(',') || [];

    const getLink = (Slug, Media) => {
        switch (slug) {
            case 'news': return { Label: get(state, 'website.NewsCTA') || 'Read', 'URL': `/${slug}/${Slug}` };
            case 'events': return { Label: get(state, 'website.EventsCTA') || 'Read', 'URL': `/${slug}/${Slug}` };
            case 'videos': return { Label: get(state, 'website.VideosCTA') || 'Watch', 'URL': get(Media, 'data.attributes.caption') };
        }
    }

    return (
        <section class={`uk-section uk-padding-remove-top ${HideTitle ? '' : 'uk-margin-medium-top'}`}>
            <div class="uk-container uk-container-large">
                <div class={`${AlignLeft ? 'uk-text-left' : 'uk-text-center'}`} hidden={HideTitle}>
                    <h2 class="uk-heading-xlarge wsio-darker-green">
                        {Title}
                    </h2>
                    <p class="uk-container uk-text-lead wsio-dark-grey">
                        {Description}
                    </p>
                </div>
                <div class="uk-padding@s" uk-filter="target: .js-filter">
                    <div class={`uk-grid-small uk-grid-divider uk-child-width-auto ${AlignLeft ? '' : 'uk-flex-center uk-text-center'}`} uk-grid>
                        <div>
                            <ul class="uk-subnav uk-flex-center uk-subnav-pill" uk-margin>
                                <li class={existingFilters.length == 0 ? `uk-active` : ''}><a {...href(genAnchor(searchParams, 1, -1))}>All</a></li>
                            </ul>
                        </div>
                        {
                            groups.map((group) =>
                                <div>
                                    <ul class="uk-subnav uk-flex-center uk-subnav-pill" uk-margin>
                                        {
                                            sortedFilters
                                                .filter(({ attributes }) => attributes.Group == group)
                                                .map(
                                                    ({ id, attributes: { Label } }) => <li data-id={id} class={existingFilters.includes(`${id}`) ? `uk-active` : ''} ><a {...href(genAnchor(searchParams, 1, id, groupMembers[group]))}>{Label}</a></li>
                                                )
                                        }
                                    </ul>
                                </div>
                            )
                        }
                    </div>
                    <div class="js-filter uk-margin-medium-top">
                        {list.map(({ Title, Date, Media, Description, Slug }, i) => <AppListItem Title={Title} SubTitle={dayjs(Date).format('dddd D MMMM YYYY')} Media={Media} Description={Description} Link={getLink(Slug, Media)} Lightbox={slug == 'videos'} Eager={i <=1} />)}
                    </div>
                    <AppPagination searchParams={searchParams} page={page} pageCount={pageCount} />
                </div>
            </div>
        </section>
    )
};